module.exports = __webpack_public_path__ + "static/media/bck.bde756bf.png";